import Vue from 'vue'
import App from './App.vue';
import router from './router';
Vue.config.productionTip = false;
Vue.prototype.baseUrl = 'https://static-af.obs.af-south-1.myhuaweicloud.com/web/statics/kinvest/img';
new Vue({
    router,
    render: (h) => {
        return h(App)
    },
}).$mount('#app')